import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const MonthlyRevenueChart = ({ data = [] }) => {
  const chartOptions = {
    title: {
      text: "Revenus par Mois",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: data.map((item) => {
        const date = new Date(2024, item.month - 1);
        return date.toLocaleString("default", { month: "short" });
      }),
    },
    yAxis: {
      title: {
        text: "Revenus",
      },
      labels: {
        formatter: function () {
          return this.value.toLocaleString("fr-FR", {
            style: "currency",
            currency: "MAD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
        },
      },
    },
    tooltip: {
      formatter: function () {
        return `<b>${this.x}</b><br/>
                Revenus: ${Number(this.y).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "MAD",
                  minimumFractionDigits: 2,
                })}`;
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Revenus",
        data: data.map((item) => Number(item.total)),
        color: "#3f8600",
        marker: {
          enabled: true,
          radius: 6,
        },
      },
    ],
    plotOptions: {
      series: {
        connectNulls: true,
        lineWidth: 3,
        states: {
          hover: {
            lineWidth: 4,
          },
        },
      },
    },
    chart: {
      style: {
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
      },
      height: 400,
      spacingTop: 20,
      spacingBottom: 20,
    },
    legend: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default MonthlyRevenueChart;
